module.exports = __webpack_public_path__ + "img/popularize04-2.b3bc1fdc.png";